import WebsiteStagingRepositoryInterface from '@/services/WebsiteStaging/interfaces';
import { AxiosInstance } from 'axios';

export default class WebsiteStagingRepository implements WebsiteStagingRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async mergeStaging(websiteId: number, userId: string): Promise<void> {
    await this.axios.post('/stagings', { websiteId, userId });
  }
}
